import React from 'react';
import { Map } from 'immutable';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import CircularProgress from '@material-ui/core/CircularProgress';
import Modal from '@material-ui/core/Modal';
import PagesTable from '@studionand/ada-next/src/components/Pages/Table';
import useStores from '../../../utils/useStores';
import { toFilterEntries } from '../../../shared/utils/mapPage';
import Card from '../../Filter/Card';
import atomicBlock from '@studionand/ada-next/src/legacy/atomicBlock';

const useStyles = makeStyles(theme => ({
  modalContent: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '80%',
    height: '80%',
    background: theme.editorPalette.common.white,
    overflow: 'auto',
    transform: 'translate(-50%, -50%)',
  },
}));

const PageReference = atomicBlock({ alignment: true })(props => {
  const { dataStore, appStore, pagesStore, uiStore } = useStores();
  const classes = useStyles();
  const [showModal, setShowModal] = React.useState(false);
  const entityKey = props.block.getEntityAt(0);
  const entity = props.contentState.getEntity(entityKey);
  const pageUuid = entity.getData().uuid;
  const hasPage = !!pageUuid;
  const [page, setPage] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const handleOpenModal = () => {
    setShowModal(true);
    props.onPreventClickAway(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    props.onPreventClickAway(false);
  };
  const handleSelectItem = item => {
    pagesStore.currentPage.updateEntityData(props.block.getKey(), entityKey, {
      uuid: item.uuid,
    });
    handleCloseModal();
  };
  React.useEffect(() => {
    const loadPage = async () => {
      setIsLoading(true);
      const page = await dataStore.pages.loadPage(pageUuid);
      if (page.error) {
        setIsLoading(false);
      } else {
        setPage(page);
        setIsLoading(false);
      }
    };
    if (hasPage) loadPage();
  }, [pageUuid]);
  return (
    <React.Fragment>
      <Box mb={4} mt={4} display="flex" justifyContent="center">
        <Box maxWidth={300}>
          {hasPage && page && (
            <Card
              data={toFilterEntries(page)}
              context={uiStore.context}
              disableLinks={appStore.editMode}
            />
          )}
          {isLoading && (
            <Box display="flex" justifyContent="center">
              <CircularProgress />
            </Box>
          )}
        </Box>
      </Box>
      {appStore.editMode && !hasPage && (
        <Box
          bgcolor="grey.200"
          p={2}
          width="100%"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Typography variant="body2" gutterBottom>
            Bitte wählen sie eine Seite aus
          </Typography>
          <Button onClick={handleOpenModal}>Seite auswählen</Button>
        </Box>
      )}
      {appStore.editMode && hasPage && (
        <Box display="flex" justifyContent="center">
          <Button onClick={handleOpenModal}>Andere Seite auswählen</Button>
        </Box>
      )}
      {showModal && (
        <Modal
          open={showModal}
          onClose={handleCloseModal}
          disableEnforceFocus={false}
          disableRestoreFocus={false}
          onClick={e => {
            // we need to do that to prevent atomic block loose focus on interaction within the modal
            //e.preventDefault();
            // e.stopPropagation();
          }}
        >
          <div className={classes.modalContent}>
            <PagesTable onSelectItem={handleSelectItem} />
          </div>
        </Modal>
      )}
    </React.Fragment>
  );
});

const plugin = () => ({
  blockRendererFn: block => {
    const type = block.getType();
    if (type === 'page-reference') {
      return {
        component: PageReference,
        editable: false,
      };
    }
    return null;
  },
  blockRenderMap: Map({
    'page-reference': {
      element: 'div',
      editable: false,
      caption: true,
      isBlockTypeMutable: false,
    },
  }),
});

export default plugin;
